// this file is automatically generated by version.generator.ts script
export const versions = {
  version: '4.88.0-beta.d5e82acb5',
  revision: 'd5e82acb5',
  branch: 'develop',
  date: 'Thu, 04 Jun 2026 14:42:23 GMT'
};